/** 角色列表默认每页数量。 */
export const AUTHZ_ROLE_DEFAULT_PAGE_SIZE = 20;

/** 角色管理使用的稳定权限码。 */
export const AUTHZ_MANAGEMENT_PERMISSIONS = {
  access: "system.role:access",
  create: "system.role:create",
  update: "system.role:update",
  grant: "system.role:grant",
} as const;

/** 角色查询根 key。 */
export const AUTHZ_ROLE_QUERY_KEY = ["authz-management", "roles"] as const;
